import { accountCountryTypes } from '../../../util/enum/api/accountCountryTypes';

export const SFH_VAULT_LOCATION = 'Dallas';

export const resolveSfhVaultSymbol = (selectedHit, account) => {
  const vaults = selectedHit?.Vaults;
  if (!Array.isArray(vaults) || vaults.length === 0) return null;
  if (account?.Country !== accountCountryTypes.US) return null;

  const dallasVault = vaults.find((v) => v?.Location === SFH_VAULT_LOCATION);
  return dallasVault?.SymbolCode || null;
};
